import React, { useEffect, useContext, useState, useCallback } from "react";
import "./Chat.scss";
import FromMe from "./FromMe";
import FromThem from "./FromThem";
import { chatListener, isTypingListener } from "../../../services/firebase/firestore/getData";
import { saveMessage } from "../../../services/firebase/firestore/saveData";
import * as storage from "../../../services/firebase/storage.js";
import FeatherIcon from "feather-icons-react";
import UserContext from "../../../services/context/userContext";
import moment from "moment";
import TextareaAutosize from "react-textarea-autosize";
import Spinner from "../../_default/Spinner";
import { updateIsTyping, updateReadState } from "../../../services/firebase/firestore/updateData";
import IsTyping from "./IsTyping";
import { useDropzone } from "react-dropzone";
import FileUploadAnimation from "./FileUploadAnimation";
import AddFilesForSending from "./AddFilesForSending";
import AlertPopup from "../../_default/AlertPopup";

export default function Chat({isChatOverview, msgSent,setMsgSent,customStyle, client_id }) {
  const [messages, setMessages] = useState(false);
  const [sending, setSending] = useState(false);
  const [clientIsTyping, setClientIsTyping] = useState(false);
  const [coachIsTyping, setCoachIsTyping] = useState(false);
  const [readStatusNotSet, setReadStatusNotSet] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [read, setRead] = useState(1);
  const [counter, setCounter] = useState(20);
  const [end, setEnd] = useState(false);
  const [fileDeleting, setFileDeleting] = useState([]);
  const [message, setMessage] = useState("");
  const user = useContext(UserContext);
  const [uploadProgress, set_uploadProgress] = useState([]);

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (uploadProgress.length < 10 && acceptedFiles.length <= 10) {
        set_uploadProgress((prevState) => {
          let newState = [...prevState];
          newState = newState.concat(acceptedFiles.map((file) => 0));
          return newState;
        });
        acceptedFiles.map((file, idx) => {
          let _index = idx + uploadProgress.length;
          uploadToFirebase(file, _index);
        });
      } else {
        setOpenPopup(true);
        setTimeout(() => {
          setOpenPopup(false);
        }, 3000);
      }
    },
    [uploadProgress]
  );

  const { getRootProps, getInputProps, open, isDragAccept, isDragReject } = useDropzone({
    noClick: true,
    noKeyboard: true,
    accept: "image/jpeg, image/png, video/mp4, application/pdf, application/zip",
    maxSize: 50000000,
    onDrop,
  });

  function uploadToFirebase(file, _index) {
    Object.assign(
      file,
      storage.uploadMedia(
        file,
        "image",
        `/clients/${client_id}/chat/coach_files/`,
        (progress) => {
          set_uploadProgress((prevState) => {
            const newState = [...prevState];
            newState[_index] = progress;
            return newState;
          });
        },
        (url) => {
          set_uploadProgress((prevState) => {
            const newState = [...prevState];
            newState[_index] = { url: url, type: file.type, name: file.name };
            return newState;
          });
        },
        (err) => {
          // set_wrongFormat("Something went wrong, contact administrator.");
          console.error("error defining media, function:  uploadToFirebase ", err);
        }
      )
    );
  }


  moment.locale("en", {
    calendar: {
      lastDay: "[Yesterday]",
      sameDay: "[Today]",
      nextDay: "[Tomorrow]",
      lastWeek: "dddd",
      nextWeek: "dddd",
      sameElse: "ddd DD MMMM",
    },
  });

  useEffect(() => {
    if (clientIsTyping) {
      updateScroll();
    }
  }, [clientIsTyping]);

  useEffect(() => {
    const typingTimer = setTimeout(() => {
      updateIsTyping(client_id, false);
    }, 10000);
    return () => clearTimeout(typingTimer);
  }, [message]);

  useEffect(() => {
    if (messages.length < 20 || !messages) {
      setTimeout(() => {
        setEnd(true);
      }, 2000);
    }
  }, [messages]);

  useEffect(() => {
    setCounter(20);
    setEnd(false);
    updateScroll();
  }, [client_id]);

  window.addEventListener("beforeunload", (event) => {
    // Cancel the event as stated by the standard.
    event.preventDefault();

    updateIsTyping(client_id, false);
  });

  let i = 1;
  useEffect(() => {
    const unsubIsTypingListener = isTypingListener(client_id, (result) => {
      setClientIsTyping(result.client_typing ? result.client_typing : false);
      setCoachIsTyping(result.coach_typing ? result.coach_typing : false);
    });
    const unsubChatListener = chatListener(counter, client_id, (result) => {
      if (result) {
        let _messages = [...result];
        let _find_read = _messages.reverse().find((e) => e.read === true && e.sender === user.id);
        let _last_index = _find_read !== -1 ? _find_read : false;
        setRead(_last_index ? _last_index.id : false);

        if (result.length > messages.length) {
          let j;
          let content = document.getElementById("chat");
          let curScrollPos = content.scrollTop;
          let oldScroll = content.scrollHeight - content.clientHeight;
          console.log("messages",result)
          // result.splice(0,1,"OK as your")
          if(result[0]?.sender===result[1]?.sender){
            result.splice(0,1,{created:result[0]?.created,id:result[0]?.id,message:"Welcome to the Aurum App - You can start a conversation with your client now.",read:result[0]?.read,sender:result[0]?.sender})
            setMessages(result);
            
          }else{
            result.splice(0,1,{created:result[0]?.created,id:result[0]?.id,message:"Welcome to the Aurum App - You can start a conversation with your client now.",read:result[0]?.read,sender:result[0]?.sender})
            setMessages(result);

          }
          let newScroll = content.scrollHeight - content.clientHeight;
          content.scrollTop = curScrollPos + (newScroll - oldScroll);
          i = j;
          if (readStatusNotSet) {
            let _others_messages = result.filter((e) => e.sender !== user.id);
            if (_others_messages.length > 0) {
              updateReadState(_others_messages[_others_messages.length - 1].id, client_id);
            } else {
              setReadStatusNotSet(true);
            }
          }
        } else if (counter === 20) {
          console.log("messages ",result)
          if(result[0]?.sender===result[1]?.sender){
            result.splice(0,1,{created:result[0]?.created,id:result[0]?.id,message:"Welcome to the Aurum App - You can start a conversation with your client now.",read:result[0]?.read,sender:result[0]?.sender})
            setMessages(result);
            
          }else{
            result.splice(0,1,{created:result[0]?.created,id:result[0]?.id,message:"Welcome to the Aurum App - You can start a conversation with your client now.",read:result[0]?.read,sender:result[0]?.sender})
            setMessages(result);

          }
          // result.splice(0,1,{created:result[0]?.created,id:result[0]?.id,message:"Welcome to the Aurum App - You can start a conversation with your faisal now.",read:result[0]?.read,sender:result[0]?.sender})
          updateScroll();
          let _others_messages = result.filter((e) => e.sender !== user.id);
          if (_others_messages.length > 0) {
            if (!_others_messages[_others_messages.length - 1].read) {
              updateReadState(_others_messages[_others_messages.length - 1].id, client_id);
            }
          } else {
            setReadStatusNotSet(true);
          }
        } else {
          setEnd(true);
        }
      } else {
        // NO MESSAGES FOUND
      }
    });
    return () => {
      unsubIsTypingListener();
      unsubChatListener();
      updateIsTyping(client_id, false);
    };
  }, [client_id, counter]);

  function sendMessage() {
    if(isChatOverview){

    }else{

      setMsgSent(!msgSent)
    }
    if (message.trim().length > 0 || (uploadProgress.length > 0 && uploadProgress.some((e) => typeof e !== "number"))) {
      setSending(true);
      let _message = {
        message: message,
        sender: user.id,
        created: new Date(),
        read: false,
      };
      if (uploadProgress.length > 0 && uploadProgress.some((e) => typeof e !== "number")) _message.content = uploadProgress;
      saveMessage(client_id, _message, (result) => {
        setSending(false);
        updateIsTyping(client_id, false);
        if (result) {
          setMessage("");
          updateScroll();
          set_uploadProgress([]);
        }
      });
    }
  }

  function updateScroll() {
    var element = document.getElementById("chat");
    if (element) {
      element.scrollTop = element.scrollHeight;
    }
  }

  function handleScroll(e) {
    if (e.target.scrollTop === 0) {
      let _counter = counter + 20;
      setCounter(_counter);
    }
  }

  function handleTyping(e) {
    if (!coachIsTyping) {
      updateIsTyping(client_id, true);
    }
    if (e.target.value[e.target.value.length - 1] !== "\n") {
      setMessage(e.target.value);
    }
    updateScroll();
  }

  function onKeyDown(e) {
    if (e.shiftKey === false && e.key === "Enter") {
      sendMessage();
    } else if (e.shiftKey === true && e.key === "Enter") {
      setMessage(message + "\n");
    } else if (e.key === "Backspace") {
      e.preventDefault();
      setMessage(message.split("").slice(0, -1).join(""));
    }
  }
  useEffect(() => {}, [uploadProgress]);

  function deleteFile(item, idx) {
    setFileDeleting((prevState) => {
      const newState = [...prevState];
      newState.push(item);
      return newState;
    });
    storage.deleteMediaFromStorage([item], () => {
      setFileDeleting((prevState) => {
        const newState = [...prevState];
        newState.splice(item, 1);
        return newState;
      });
      const _uploadProgress = [...uploadProgress];
      _uploadProgress.splice(idx, 1);
      set_uploadProgress(_uploadProgress);
    });
  }

  return (
    <>
      <AlertPopup message="Max 10 items at the time." open={openPopup} />
      <div style={customStyle} className={`c-chat-wrapper ${isDragAccept ? "--isDragAccept" : ""} ${isDragReject ? "--isDragReject" : ""}`} {...getRootProps()}>
        <div className="c-chat-window" id="chat" onScroll={handleScroll}>
          <div className="c-chat-spinner">{!end && <Spinner />}</div>
          {messages &&
            messages.map((message, idx) => {
              let date = moment(new Date(message.created.toDate())).startOf("day");
              let _prev_date = moment(new Date(message.created.toDate())).startOf("day").subtract(1, "days");
              let _next_date = moment(new Date(message.created.toDate())).startOf("day").add(1, "days");
              let type = "alone";
              let _prev_sender = messages[idx - 1] ? messages[idx - 1].sender : "";
              let _next_sender = messages[idx + 1] ? messages[idx + 1].sender : "";
              if (idx > 0) {
                _prev_date = moment(new Date(messages[idx - 1].created.toDate())).startOf("day");
              }
              if (idx < messages.length - 1) {
                _next_date = moment(new Date(messages[idx + 1].created.toDate())).startOf("day");
              }
              if (_prev_sender === message.sender && _next_sender === message.sender) {
                type = "middle";
                if (moment(_next_date).isAfter(date) && moment(_prev_date).isBefore(date)) {
                  type = "alone";
                } else if (moment(_next_date).isAfter(date)) {
                  type = "last";
                } else if (moment(_prev_date).isBefore(date)) {
                  type = "first";
                }
              } else if (_prev_sender !== message.sender && _next_sender === message.sender) {
                type = "first";
                if (moment(_next_date).isAfter(date) && moment(_prev_date).isBefore(date)) {
                  type = "alone";
                } else if (moment(_next_date).isAfter(date)) {
                  type = "last";
                } else if (moment(_prev_date).isBefore(date)) {
                  type = "first";
                }
              } else if (_prev_sender === message.sender && _next_sender !== message.sender) {
                type = "last";
                if (moment(_next_date).isAfter(date) && moment(_prev_date).isBefore(date)) {
                  type = "alone";
                } else if (moment(_next_date).isAfter(date)) {
                  type = "last";
                } else if (moment(_prev_date).isBefore(date)) {
                  type = "first";
                }
              }
              return (
                <div key={idx} className="c-message">
                  {moment(_prev_date).isBefore(date) && (
                    <p className="c-date">
                      {moment(new Date(message.created.toDate())).calendar()} <span>{moment(new Date(message.created.toDate())).format("HH:mm")}</span>
                    </p>
                  )}
                  {message.sender === user.id ? <FromMe read={read === message.id} idx={idx} message={message} type={type} /> : <FromThem idx={idx} message={message} type={type} />}
                </div>
              );
            })}

          {clientIsTyping && (
            <div className={"from-them --typing"}>
              <div className="c-is-typing">
                <IsTyping size={20} />
              </div>
            </div>
          )}
        </div>
        <div className="c-chat-input-wrapper">
          <AddFilesForSending fileDeleting={fileDeleting} deleteFile={deleteFile} uploadProgress={uploadProgress} />

          <div className="c-chat-input-create">
            <TextareaAutosize placeholder="Type a message..." maxRows={4} value={message} onKeyDown={(e) => onKeyDown(e)} onChange={(e) => handleTyping(e)} />
            <input {...getInputProps()} />
            <div className="c-chat-btns">
              <button onClick={() => open()} className="c-chat-attachment-btn">
                <FeatherIcon icon="paperclip" size="15" />
              </button>
              <button onClick={() => sendMessage()} className={message.trim().length > 0 ? (uploadProgress.length > 0 && uploadProgress.some((e) => typeof e === "number") ? "c-chat-send-btn" : "c-chat-send-btn --active") : uploadProgress.length > 0 && !uploadProgress.some((e) => typeof e === "number") ? "c-chat-send-btn --active" : "c-chat-send-btn"}>
                {sending ? <Spinner size={22} /> : <FeatherIcon icon="send" size="17" />}
              </button>
            </div>
          </div>
        </div>

        <div className="c-typing-info" style={message.trim().length > 0 ? { opacity: 1 } : { opacity: 0 }}>
          <p>
            <b>Return</b> to send
          </p>
          <p>
            <b>Shift + Return</b> to add a new line
          </p>
        </div>
        <div className="c-chat-dragdrop-overlay">
          <div className="drag-accept-image">
            <FileUploadAnimation />
          </div>
          <p className="drag-accept-text">Drop here to upload content.</p>
          <p className="drag-reject-head">Wrong file type.</p>
          <p className="drag-reject-text">suported file types are: .jpeg, .png, .mp4, .pdf, .zip</p>
        </div>
      </div>
    </>
  );
}
